export const enterpriseTabs = {
    VERSIONS: 'versions',
    ERRORS: 'errors',
};
